import React from "react";

const Portfolio = () => {
  return (
    <>
      <h1>Portfolio</h1>

        <div classname="projectCards">
            <p classname="projectTitle">Real Gay Garage</p>
            <p classname="projectDescription">Online Fitness Platform mainly used for client booking purposes</p>
            <p classname="projectDescription">Wix.com, Ascend Business, HTML, CSS</p>
          <p>Freelance project development on Wix.com launched for fitness professional client, Nicholas Spadaro.</p>
          <p classname="projectDate">January 2021 to Present</p>
          <a href="https://www.realgaygarage.com/">wwww.realgaygarage.com</a>
        </div>

    </>
  );
};

export default Portfolio;
